import { cn } from '@/lib/utils';
import NoItems from '@/components/ui/NoItems.tsx';
import { AcceptanceDocumentVm } from '@/features/dashboard/bookingChanges/types/ChangePackageFlowViewModel.ts';
import AcceptanceDocumentListHeader from './AcceptanceDocumentListHeader.tsx';
import AcceptanceDocumentRow from './AcceptanceDocumentRow.tsx';

interface AcceptanceDocumentListProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onToggle'> {
  documents: AcceptanceDocumentVm[];
  selectedIds: string[];
  onToggle: (document: AcceptanceDocumentVm) => void;
}

/**
 * Blok „Dokumenty do ponownej akceptacji” w kroku W2: co klient podpisze
 * jeszcze raz, zanim paczka wejdzie w życie.
 */
const AcceptanceDocumentList = ({
  documents,
  selectedIds,
  onToggle,
  className,
  ...props
}: AcceptanceDocumentListProps) => (
  <div className={cn('border-t border-neutral-200 pt-4', className)} {...props}>
    <AcceptanceDocumentListHeader
      documents={documents}
      selectedIds={selectedIds}
    />

    {documents.length === 0 ? (
      <NoItems
        className="mt-3"
        title="Brak dokumentów do podpisu"
        description="Ta paczka nie narusza żadnej zgody ani umowy — zapisujący nie musi niczego podpisywać ponownie."
      />
    ) : (
      <div className="mt-1.5 flex flex-col">
        {documents.map((document, index) => (
          <AcceptanceDocumentRow
            key={document.id}
            className={cn(index > 0 && 'border-t border-neutral-100')}
            document={document}
            selectedIds={selectedIds}
            onToggle={onToggle}
          />
        ))}
      </div>
    )}
  </div>
);

export default AcceptanceDocumentList;
